// progress
import Progress from "../../../components/progress/progress";
// hook
import { useEffect, useRef } from "react";
// @ts-ignore
import Cookies from "js-cookie";

const FinalStep = () => {
    const progress = useRef<HTMLElement | any>(null);
    useEffect(() => {
        setTimeout(() => {
            progress.current.classList.add('w-100');
        }, 1000)
    }, []);
    return (
        <>
            <Progress number={6} />
            <section className={'container h-100 pb-3'}>
                <div className={'row align-items-center my-5 h-100 justify-content-center'}>
                    <div className={'col-lg-7 col-md-7 col-12 text-center'}>
                        <h4 className={'text-white fw-bold'}>به ایران تراکنش خوش آمدید</h4>
                        <p className={'text-white fw-light mt-4'}>
                            کد ایران تراکنشی شما
                            <br />
                            {Cookies.get('mobileNumber')}
                        </p>
                        <div className={'progress'}>
                            <div ref={progress} className={'progress-bar w-25'}></div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )

}

export default FinalStep;